import axios from "axios"
import * as env from "../constants/env"
import { utils } from "../helpers"


/* Headers Of Every Request */
const getHeaders = () => {

    const token = localStorage.getItem("token")

    return { headers: { Authorization: `Bearer ${token}` } }
}


/* List Players */
export const list = ({ page = 1, search = "", operators = "", tables = "", start = "", end = "", testers = false, vips = true, sort = "", reporting = false }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ page: page || 1, timezone: utils.getTimezone() })

    if (search) params.set("search", search)
    if (operators) params.set("operators", operators)
    if (tables) params.set("tables", tables)
    if (start) params.set("start", start)
    if (end) params.set("end", end)
    if (sort) params.set("sort", sort)
    if (!testers) params.set("testers", "0")
    if (!vips) params.set("vips", "0")
    if (reporting) params.set("reporting", "1")

    /* Send Request */
    const uri = `${env.startpoint}player/list?${params.toString()}`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Filters Of The Section (операторы и игры — строго в рамках доступа токена) */
export const filters = () => {

    const uri = `${env.startpoint}player/filters`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Sessions Of A Player */
export const sessions = ({ player }) => {

    const params = new URLSearchParams({ player, timezone: utils.getTimezone() })
    const uri = `${env.startpoint}player/sessions?${params.toString()}`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Rounds Of A Player */
export const rounds = ({ player, page = 1, sid = "", tables = "", start = "", end = "" }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ player, page: page || 1, timezone: utils.getTimezone() })

    if (sid) params.set("sid", sid)
    if (tables) params.set("tables", tables)
    if (start) params.set("start", start)
    if (end) params.set("end", end)

    /* Send Request */
    const uri = `${env.startpoint}player/rounds?${params.toString()}`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Statistics Of A Player */
export const statistics = ({ player }) => {

    const params = new URLSearchParams({ player, timezone: utils.getTimezone() })
    const uri = `${env.startpoint}player/statistics?${params.toString()}`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Statistics Of One Game Over A Period */
export const periodStatistics = ({ player, game, start, end, dates = [] }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ player, game, start, end, timezone: utils.getTimezone() })

    /* Check Dates — the columns of the chart travel as a JSON array */
    if (dates && dates.length > 0) {
        params.set("dates", JSON.stringify(dates))
    }

    /* Send Request */
    const uri = `${env.startpoint}player/period?${params.toString()}`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Список контроля входа — читаем, добавляем, убираем */
export const watchList = () => {

    const uri = `${env.startpoint}player/watch`

    return axios.get(uri, getHeaders()).then((response) => response).catch((data) => data.response)
}


export const watchAdd = (data) => {

    const uri = `${env.startpoint}player/watch`

    return axios.post(uri, data, getHeaders()).then((response) => response).catch((data) => data.response)
}


export const watchRemove = (data) => {

    const uri = `${env.startpoint}player/watch-remove`

    return axios.post(uri, data, getHeaders()).then((response) => response).catch((data) => data.response)
}


/* Change A Flag Of A Player */
export const toggle = (data) => {

    const uri = `${env.startpoint}player/change`

    return axios.post(uri, data, getHeaders()).then((response) => response).catch((data) => data.response)
}
